const PageHelpCenter = () => import('@/modules/xmsb/helpcenter/PageHelpCenter')

export default [
  {

    path: '/helpcenter',
    name: 'helpcenter',
    component: PageHelpCenter,
    meta: {
      title: '帮助中心',
      isBlack: true
    },
  },
]
